<template>
	<div class="qualityenterprise">
		<leftnav class="fl" :mkcode="mkcode" itemcode="A-QBNZQY" docutitle="科技招商"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="25vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox" style="padding-bottom: 1px;">
					<div class="right_boxtitle" v-if="userdata.zsdn_version == 2">
						<span class="fl right_title">企业</span>
						<div class="fl search-box nz-search-box">
							<span class="searchtype">全部内资企业库</span>
							<input type="text" placeholder="请输入企业名称" class="search-input" v-model="searchtext" @keydown="searchenter" />
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div>
					</div>
					<div class="right_boxtitle" v-else> 
						<div class="right_boxtitle map_title_tab">
						<span class="title" @click="routerself('/science')">已获投资科技企业</span>
						<span class="title current">获重要资质科技企业</span>
						
					</div>
					</div>
					<div class="opport-screen-list1"> 
						<dl class="opport-screen bdbe" v-if="userdata.zsdn_version == 2">
							<dt class="fl">企业库</dt>
							<dd class="fl" v-if="curWebsite.type != 5">
								<span :key="index" v-for="(item,index) in enterinarr"
									@click="routerself('/enterpriseList?type='+item.type+'&Pt='+item.curindex);"
									class="a-screen">{{item.name}}</span>
								<span  class="a-screen current">全部内资企业库</span>
								<span class="blueline"></span>
								<span @click="routerself('/foreignEnterprises')" class="a-screen">境外上市企业库</span>
								<span @click="routerself('/forcapEnterprise')" class="a-screen">外资企业库</span>
								<!-- 2024.4.29暂时隐藏 -->
								<!-- <el-tooltip class="item smartTip-text" effect="light" placement="top-start"><i
										class="el-icon-question listeltootipicon"></i>
									<div slot="content" class="list_tips">
										<p>上市公司：A股上市的公司 </p>
										<p>龙头企业：规模大、投资实力强、在行业内占据优势地位的企业</p>
										<p>创新企业：被专业投资机构认可并成功融资的企业</p>
										<p>优质企业：具有市场竞争优势和持续发展潜力的企业</p>
										<p>外资企业：外商投资的企业</p>
										<p>境外上市企业：在境外证券交易所公开上市的企业</p>
									</div>
								</el-tooltip> -->
								<video-teaching :type="1"></video-teaching>
							</dd>
							<dd class="fl" v-if="curWebsite.type == 5">
								<span :key="index" v-for="(item,index) in tz_enterinarr"
									@click="routerself('/enterpriseList?type='+item.type);"
										class="a-screen">{{item.name}}</span>
								<span class="a-screen current">全部内资企业</span>
								<el-tooltip class="item smartTip-text" effect="light" placement="top-start"><i
										class="el-icon-question listeltootipicon"></i>
									<div slot="content" class="list_tips">
										<p>创新企业：被专业投资机构认可并成功融资的企业</p>
										<p>优质企业：具有市场竞争优势和持续发展潜力的企业</p>
									</div>
								</el-tooltip>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="userdata && userdata.zsdn_version == 2 && enterinarr.length>0">
							<dt class="fl">企业类型</dt>
							<dd class="fl" >   <!--v-if="curWebsite.type != 5"-->
								<span :key="index" v-for="(item,index) in childrenEnterinArr"
									@click="searchtype = item.type,clearNotion();ajaxsearchcompany()"
									:class="searchtype == item.type?'a-screen current':'a-screen'">{{item.name}}</span>
							</dd>
						</dl>
						<!-- ajaxsearchcompany() -->
						<!-- <dl class="opport-screen bdbe">
								<dt class="fl">科技实力</dt>
								<dd class="fl">
									<span :key="index" v-for="(item,index) in qyslitagCom"@click="commontagcode=item.tagCode;ajaxsearchcompany()":class="commontagcode == item.tagCode ?'a-screen current' : 'a-screen'">{{item.tagName}}</span>
								</dd>
							</dl> -->
						<dl class="opport-screen bdbe" v-show="searchtype != 2">
							<dt class="fl">企业实力</dt>
							<dd class="fl ">
								<!--  	:style=" index<7?'font-weight:bold':''" -->
								<span @click="qyslClick(0,'qysl')"
									:class="comSearchdata[0] == 0 ?'a-screen current' : 'a-screen'">全部</span>
								<span :key="item.tagCode" v-for="(item) in totalqysl"
									@click="qyslClick(item.tagCode,'qysl')"
								 :class="{'a-screen':true,'current':comSearchdata[0] == item.tagCode,'fwb':item.fwb}">{{item.tagName}}</span>
							 </dd>
						</dl>
						<dl class="opport-screen bdbe" v-if="searchtype == 2">
							<dt class="fl">融资轮次</dt>
							<dd class="fl ">
								<div class="fl" :key="index" v-for="(item,index) in financing_rounds">
									<span @click="qyslClick(item.tagCode,'investRound')"
										:class="investRound == item.tagCode ?'a-screen current' : 'a-screen'"
										:style="index>0 && index<8?fontb:''">{{item.tagName}} </span>
								</div>
							</dd>
						</dl>
						<!-- 产业概念细分筛选 -->
						<notionScreen v-if="userdata.zsdn_version == 1"
						:type="2"  
						:notionNumberList="notionNumList"  
						:refreshNum="notionNumRefresh"
						:token="userdata.token" 
						@chooseNotion="chooseNotion" 
						:isShowNotionScreen="true"
						:isClearNotion="isClearNotion"
						:showNotionExtend="userdata.zsdn_version == 2"
						:showSimpleNotion="userdata.zsdn_version == 1"
						:isIntegration="isIntegration" 
						:ucomputer ="ucomputer"
						:defaultSelected="userdata.zsdn_version == 2?'':'simpleNotion'"
						:showFirstList="userdata.zsdn_version == 2"
						></notionScreen>
					 <!-- 省市区筛选 -->
						<cityScreen @getEnterpriseList="cityScreenFun" :isShowTips=false :showTipsType="showTipsType"></cityScreen>
						<dl class="opport-screen bdbe" v-show="userdata.zsdn_version == 2">
							<dt class="fl">科技实力</dt>
							<dd class="fl">
								<div class="selecttag" :key="i" v-for="(list,i) in qyslitagPublicselect">
									<select :name="list.tagCode" @change="choosetaglist1($event,i)">
										<option value="empty">{{list.tagName}}</option>
										<option :value="item.tagCode" :key="index"
											v-for="(item,index) in list.children">{{item.tagName}}</option>
									</select>
								</div>
							</dd>
						</dl>
						<!-- 产业概念细分筛选 -->
						<notionScreen v-if="userdata.zsdn_version == 2"
						:type="2"  
						:notionNumberList="notionNumList"  
						:refreshNum="notionNumRefresh"
						:token="userdata.token" 
						@chooseNotion="chooseNotion" 
						:isShowNotionScreen="true"
						:isClearNotion="isClearNotion"
						:showNotionExtend="userdata.zsdn_version == 2"
						:showSimpleNotion="userdata.zsdn_version == 1"
						:isIntegration="isIntegration" 
						:ucomputer ="ucomputer"
						:defaultSelected="userdata.zsdn_version == 2?'':'simpleNotion'"
						:showFirstList="userdata.zsdn_version == 2"
						:isShowFutureIndustries = 'true'
						></notionScreen>
					</div>
				</div>

				<div class="whitebox" style="min-height: 160px;" v-loading="tableLoading">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" v-if="!kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
						<p class="fl" v-if="kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条【 <span
								class="orangefont">{{kwtextsearchtext}}</span>】相关结果</p>
						<div :class="exportbtn?'fr enlistexportbtn':'fr enlistexportbtn disable'"
							@click="enlistExport()" v-if="userdata.groupType == 1"
							v-show="exportnum>0 && enterpristlist.length>0">
							<span>导出数据</span>
						</div>
					</div>
					<!-- 多维度分数筛选 全部内资企业删除排序功能-->
					<ul class="dimensionScreen oh w95mg" v-show="enterpristlist.length>0">
						<li :class="orderField == list.type ?'fl current ':'fl '" :key="index"
							v-for="(list,index) in dimensionList" @click="tablesort(list.type);"
							v-show="list.name!='融资时间'||searchtype == 2">
							<span :class="orderField == list.type ?'sortname current ':'sortname '">{{list.name}}</span>
							<span :class="ordertype == 1?'timesorticon up':'timesorticon down'"></span>
						</li>
					</ul>
					<div class="enterprise_list_box" v-show="enterpristlist.length!=0">
						<!-- 全部内资企业 -->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>排名</th>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th>
								<th>地区</th>
								<th>企业实力</th>
								<th>编辑</th>
							</tr>
							<tr :key="i" v-for="(list,i) in enterpristlist">
								<td>{{(page-1)*pageSize+i+1}}</td>
								<td class="title" @click="routerlinkid('/enterprises',list.stockCode,curindex)">
									{{list.title}}</td>
								<td class="conpanytags hastag">
									<span class="span-tag" :key="index" v-for="(item,index) in list.notionlist"
										@click="tagrouter('/enterpriseTag',0,'notion',item.id,item.name)">{{item.name}}</span>
								</td>
								<td class="conpanytags notiontags">
									<span class="span-tag" :key="index" v-for="(item,index) in list.taglist"
										@click="tagrouter('/enterpriseTag',0,'tag',item.id,item.name)">{{item.name}}</span>
								</td>
								<td>{{list.area}}</td>
								<td>{{list.zs100000}}</td>
								<td class="collectfont1"><span
										@click="listToggleCollect(list)">{{list.collectId == 0?'加入':'移除'}}<br />目标企业</span>
								</td>
							</tr>
						</table>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>
			</div>
			<!-- 导出列表弹框 -->
			<div class="enlistexportPop" v-show="exportpop">
				<div class="enlistexportPop_box">
					<h5 class="title">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</h5>
					<p class="smtips">单次最多导出500条，每日最多可以导出10次</p>
					<p class="tips">本次可导出<b class="redfont">{{total>500?500:total}}</b>条，今日剩余次数<b
							class="redfont">{{exportnum}}</b>次</p>
					<span class="determinebtn" @click="exportlistFun()">{{confirmtext}}</span>
					<span class="closebtn" @click="exportpop=false"></span>
				</div>
			</div>
		</div>
		<iframe :src='iframeurl' style="width: 1px;height: 1px;" frameborder="none" id="exportIframe"></iframe>
	</div>
</template>

<script> 
	import {totalqysl,totalqysl_yz,totalqysl_ss,financing_rounds,totalqysl_lt,totalqysl_simple} from '@/utils/enterprise-tag.js'
	import { mapState, mapMutations, mapGetters } from "vuex";
	
	export default {
		name: 'enterpriseList',
		computed: {
		...mapState({
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				curWebsite:this.$api.getWebsiteType(),
				title: "全部内资企业",
				searchPlaceholder: '请输入企业名称',
				fenkd: {
					children: []
				},
				tableLoading: false,
				curindex: 6,
				childrenEnterinArr:[
					{P_type: 0,type: 0,name: "全部",},
					{P_type: 1,type: 9,name: "A股上市龙头企业",},
					{P_type: 1,type: 'A090206',name: "港股中资企业",},
					{P_type: 1,type: 'A090208',name: "美股中资企业",},
					{P_type: 1,type: 1,name: "非上市龙头企业",},
					{P_type: 2,type: 2,name: "创投企业",},
					{P_type: 2,type: 3,name: "优质企业",}
				],
				enterinarr: [
					{curindex: 1,type: 9,name: "龙头企业库",tagnum: 10010,},
					{curindex: 2,type: 2,name: "科创企业库",tagnum: 10010,},
				],
				tz_enterinarr: [{
						pagecode: 'A-CXQY',
						type: 2,
						name: "创新企业",
						tagnum: 3,
						hxtagname: '&拿地信息&股权投资信息&财力稳健&项目投资信息&融资时间标签&融资金额标签&'
					},
					{
						pagecode: 'A-YZQY',
						type: 3,
						name: "优质企业",
						tagnum: 10009,
						hxtagname: '&拿地信息&股权投资信息&'
					},
				],
				userdata: {token:''},
				notionCode: 0,
				chooseNotionlist: [0, 0, 0, 0, 0],
				searchtype: 0,
				searchtext: "",
				kwtextsearch: false,
				kwtextsearchtext: "", 
				notionNumRefresh:1,
				isClearNotion:false,
				notionNumList:[],
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数 
				provinceid: 0,
				cityid: 0,
				countyid: 0, 
				citydata: [],
				countydata: [],
				fontb: {
					fontWeight: 'bold'
				},
				initialTagdata: [{
					tagName: "",
					tagCode: "",
					children: []
				}],
				qyslitagCom: [], //公共科技实力
				qyslitagPublicselect: [], //公共科技实力下拉框版
				comSearchdata: [0, 'empty', 'empty', 'empty'], //公共科技实力下拉框版 存储值
				qysltagUnique: [], //独有企业实力（全部内资企业集合 上市公司和优质企业的企业实力） 
				totalqysl:[],
				financing_rounds:[],//融资轮次标签
				investRound:'',//融资轮次
				totalqysl_shangshi: [ ],
				totalqysl_youzhi: [ ],
				searchtagdata: ['0'],
				enterpristlist: [],
				usertaglist: [],
				num: 0,
				orderField: 0, //排序字段 0 分数 1 时间
				ordertype: 0, //排序方式 0 降序 1 升序   
				commontagcode: 0,
				tyinitialTagdata: [],
				exportnum: 0, //导出次数
				exportpop: false, //点击导出按钮弹框显示
				allowexport: false, //后台判断是否可以上传
				exportbtn: true, //loading小 等待转圈圈
				confirmtext: '确认导出',
				iframeurl: '',
				notionstep: 0,
				// 0=分数,1=融资时间,2=企业实力,3=投资力度,4=本省关联度,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量
				dimensionList: [{
					name: '综合',
					type: 0
				}, {
					name: '拿地数量',
					type: 5
				}, {
					name: '拿地面积',
					type: 6
				}, {
					name: '拿地金额',
					type: 7
				}, {
					name: '投资项目数量',
					type: 8
				}, {
					name: '投资项目金额',
					type: 9
				}, {
					name: '控制企业',
					type: 10
				}, ],
				isIntegration:true,
				ucomputer:false, //不计算概念数量，港股和美股暂无数据所以不计算
				showTipsType:3,
				isShowFreeUserTips:false,
				mkcode:'A',
			}
		},
		//监听路由变化、newVal：目标路由，oldVal:原路由，路由不同时重新请求数据
		watch: {
			searchtype(newVal, oldVal) {
				console.log('watch',newVal,oldVal);
				if(newVal == 0){
					this.totalqysl = totalqysl();
					this.ucomputer = false;
					this.showTipsType = 3;
				}
				if(newVal == 9){ //上市公司
					this.totalqysl = totalqysl_ss();
					this.ucomputer = false;
					this.showTipsType = 3;

				}else if(newVal == 2){ //创新企业是融资轮次所以单独做
					this.ucomputer = false;
					this.showTipsType = 4;

					
				}else if(newVal == 1){ //龙头企业
					this.totalqysl = totalqysl_lt();
					this.ucomputer = false;
					this.showTipsType = 3;

				}else if(newVal == 3){ //优质企业

					this.totalqysl = totalqysl_yz();
					this.ucomputer = false;
					this.showTipsType = 4;


				}else if(newVal == 'A090206' || newVal == 'A090208'){
					this.showTipsType = 3;
					// this.ucomputer = true;
				}
			}
		},
		beforeCreate() {
			// this.bus.$emit('loading', true);
		},
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			}); 
			this.userdata = this.getuseriformation() || {};
			if(this.userdata.zsdn_version == 1){
				this.mkcode = 'D';
			}else{
				this.mkcode = 'A';
			}
		},
		mounted() { 
			if(this.userdata.zsdn_version == 1){
				this.totalqysl=totalqysl_simple(); 
			}else{
				this.totalqysl=totalqysl(); 
			}
			
			this.financing_rounds = financing_rounds();
			console.log('totalqysl:', this.totalqysl);
			document.getElementById('app').style.background = "#f0f3f5";
			this.getCommonTaglist(2);
			this.comSearchdata = this.$route.query.tag ? [this.$route.query.tag] :this.comSearchdata;
			this.ajaxsearchcompany(1);
			if(this.curWebsite.type == 5){
				document.title = '全部内资企业库-'+this.curWebsite.shortname;
			}
		},
		methods: {
			qyslClick(tagCode,type){
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					return;
				}
				if(type == 'qysl'){
					this.comSearchdata[0]= tagCode;
					this.clearNotion();
				}else if(type == 'investRound'){
					this.investRound= tagCode;

				}
				this.ajaxsearchcompany()
			},
			getajaxUrl(apiurl, searchtype) {
				if (searchtype != 'search') {
					this.searchtext = "";
				}
				var _this = this,
					ajaxurl = '';
				//公司列表 type:1/2 area:provinceid industry行业id capital 注册资本 （暂无） 标签（暂无） chain相关产业链（暂无） page页码
				var searchtagdata1 = this.searchtagdata.filter(item => {
					return item != 'empty' && item != 0;
				});
				this.comSearchdata.forEach(item => {
					if (item != 'empty' && item != 0) {
						searchtagdata1.push(item);
					}
				})
				if (this.searchtype == 'A090206' || this.searchtype == 'A090208') { //港美股中资企业专用
					searchtagdata1.push(this.searchtype);
				}
				// console.log('searchtagdata1',searchtagdata1,this.searchtagdata) 
				var tagaja = '';
				if (searchtagdata1.length > 0) {
					tagaja = _this.datajoin('tag', searchtagdata1);
				}
				
				var notionja = this.splicing('notion', this.notionCode);
				var kwaja = this.splicing('kw', this.searchtext);
				var countyidja = this.splicing('county', this.countyid);
				var provinceidja = this.splicing('province', this.provinceid);
				var cityidja = this.splicing('city', this.cityid);
				ajaxurl = apiurl + '?type=' + this.searchtype + '&search=1' + tagaja + "&orderField=" + this
					.orderField + "&orderType=" + this.ordertype + notionja + kwaja + countyidja + provinceidja + cityidja;
				if (this.searchtype == 2) {
					ajaxurl = ajaxurl + this.splicing('investRound', this.investRound);
				}
				if (this.searchtype == 'A090206' || this.searchtype == 'A090208') { //港美股中资企业专用 type=0
					ajaxurl = apiurl + '?type=0' + '&search=1' + tagaja + "&orderField=" + this
					.orderField + "&orderType=" + this.ordertype + notionja + kwaja + countyidja + provinceidja + cityidja;
				}
				return ajaxurl
			},
			//企业列表导出数据
			enlistExport() {
				if (this.exportbtn) {
					this.exportpop = true;
				} 
			},
			exportlistFun() { //下载报告
				var _this = this;
				var ajaxurl = this.getajaxUrl(this.$api.cyl.enterprise.export(), 'search') + '&token=' + this.userdata
					.token;
				this.confirmtext = "导出中";
				var iframe = document.getElementById("exportIframe");
				iframe.setAttribute("src", ajaxurl);
				_this.exportnum = this.exportnum--;
				setTimeout(() => {
					_this.confirmtext = "导出成功";
					_this.exportpop = false;
					_this.exportbtn = false;
				}, 5000)
				setTimeout(() => {
					_this.exportbtn = true;
					_this.confirmtext = "确认导出";
					console.log('一分钟冷却计时')
				}, 60000)
			},
			//时间/分数升降序
			tablesort(field) {
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					return;
				}
				if (field == this.orderField) {
					this.ordertype = Math.abs(this.ordertype - 1);
				} else {
					this.orderField = field;
				}
				this.ajaxsearchcompany();
			},
			//搜索关键词
			searchkwfun() {
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					return;
				}
				this.searchtext = $.trim(this.searchtext);
				if (this.searchtext.length > 0) {
					var pathque = {
						kw: this.searchtext
					};
					this.routerlinkarry('/totalSearch', pathque);
				} else {
					this.$message({
						type: 'error',
						message: '请输入关键词搜索',
					});
				}
			},
			searchenter(e) {
				if (e.keyCode == 13) {
					this.searchkwfun();
				}
			},
			//画像标签高级搜索
			getCommonTaglist(type) {
				var _this = this;
				this.$axios.get(this.$api.tag.tag.list() + '?categoryId=' + type, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log('commontaglist', res.data);
					var tagdsta = res.data.list.filter(data => {
						return data.children.length > 0;
					})
					// for (var i = 0; i < tagdsta.length; i++) {
					// 	_this.searchtagdata.push('empty');
					// }
					//企业通用标签 
					var datalen = tagdsta.length;
					_this.qyslitagCom = tagdsta[datalen - 1].children; //科技实力
					// console.log('企业通用标签',_this.qyslitagCom);
					var ddd = [];
					// 科技专项  国家科技重大专项 国家薪火项目 国家重大科学仪器设备开发专项 &&科技奖项  国家标准起草单位 国家级科学技术进步奖 中国专利奖 创新积分500强&&研发中心 国家地方联合工程研究中心 国家级工业设计中心 高新技术企业研发中心 企业国家重点实验室 认定企业技术中心 院士专家工作站 博士后工作站 博士后流动站 国家技术创新示范企业

					let dgas =
						'&国家科技支撑计划-A021501&国家科技重大专项-A021502&国家标准起草单位-A021503&国家薪火项目-A021504&国家级科学技术进步奖-A021505&国家地方联合工程研究中心-' +
						'A021506&国家重大科学仪器设备开发专项-A021507&国家级工业设计中心-A021508&高新技术企业研发中心-A021509&企业国家重点实验室-A021510&认定企业技术中心-A021511&院士专家工作站-' +
						'A021512&博士后工作站-A021513&博士后流动站-A021514&中国专利奖-A021515&国家技术创新示范企业-A021516&创新积分500强-A021517';
					var selectddd = [
						//{tagName:"中国专利奖",tagCode:"A021515"}2,{tagName:"认定企业技术中心",tagCode:"A021511"}3,
						{
							tagName: "科技专项",
							tagCode: 'empty',
							children: [{
								tagName: "国家科技重大专项",
								tagCode: "A021502"
							}, {
								tagName: "国家薪火项目",
								tagCode: "A021504"
							}, {
								tagName: "国家重大科学仪器设备开发专项",
								tagCode: "A021507"
							}]
						},
						{
							tagName: "科技奖项",
							tagCode: 'empty',
							children: [{
								tagName: "国家标准起草单位",
								tagCode: "A021503"
							}, {
								tagName: "国家级科学技术进步奖",
								tagCode: "A021505"
							}, {
								tagName: "创新积分500强",
								tagCode: "A021517"
							}]
						},
						{
							tagName: '研发中心',
							tagCode: 'empty',
							children: [{
								tagName: "国家地方联合工程研究中心",
								tagCode: "A021506"
							}, {
								tagName: "国家级工业设计中心",
								tagCode: "A021508"
							}, {
								tagName: "高新技术企业研发中心",
								tagCode: "A021509"
							}, {
								tagName: "企业国家重点实验室",
								tagCode: "A021510"
							}, {
								tagName: "院士专家工作站",
								tagCode: "A021512"
							}, {
								tagName: "博士后工作站",
								tagCode: "A021513"
							}, {
								tagName: "博士后流动站",
								tagCode: "A021514"
							}, {
								tagName: "国家技术创新示范企业",
								tagCode: "A021516"
							}]
						},
						{
							tagName: '名企背景',
							tagCode: 'empty',
							children: [{
								tagName: "华为系",
								tagCode: "A021701"
							}, {
								tagName: "字节系",
								tagCode: "A021702"
							}, {
								tagName: "腾讯系",
								tagCode: "A021703"
							}, {
								tagName: "阿里系",
								tagCode: "A021704"
							}, {
								tagName: "百度系",
								tagCode: "A021705"
							}, {
								tagName: "京东系",
								tagCode: "A021706"
							}, {
								tagName: "美团系",
								tagCode: "A021707"
							}, {
								tagName: "小米系",
								tagCode: "A021708"
							}, ]
						}
					]
					_this.qyslitagPublicselect = selectddd;
					_this.qyslitagCom.unshift({
						tagName: "全部",
						tagCode: "0"
					});
					_this.tyinitialTagdata = tagdsta; //通用画像标签储存

				});
			}, 
 
			//选择标签
			choosetaglist1(obj, index) { 
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					return;
				}
				this.comSearchdata[index + 1] = obj.target.value;
				console.log(this.comSearchdata);
				this.ajaxsearchcompany();
			},
			pageHandler: function(page) {
				this.ajaxsearchcompany(page, 'sort', 'search');
			},
			//判断权限进行跳转
			judgeViewPermissions(page) {

			},
			//省份城市选择
			cityScreenFun(pid,cid,cuid){
				this.clearNotion();
				this.cityid = cid;
				this.countyid = cuid; 
				this.provinceid = pid;
				this.ajaxsearchcompany(1, 'sort');
			},
			//清空概念选项
			clearNotion() {
				this.notionNumRefresh++;
				this.isClearNotion=true; 
				this.notionCode = 0;
			},
			//概念单选 层级显示
			chooseNotion(chooseNotionlist,notionCode,step){ 
				this.notionCode=notionCode;  
				if(step){
					this.notionstep = step; 
				}
				var sortStr =  (step && step < 3) ? 'sort':''; 
				if(step && step < 3){
					sortStr = 'sort';
				}else if(step && step <4 && this.isIntegration){
					if(this.notionCode.indexOf('B')>-1||this.notionCode.indexOf('D')>-1||this.notionCode.indexOf('E')>-1||this.notionCode.indexOf('F')>-1){
						sortStr = 'sort';
					}
				}
				this.ajaxsearchcompany(1,sortStr); 
			},
			
			ajaxsearchcompany(pages, citytype, searchtype) {
				console.log('搜索企业',pages, citytype, searchtype);
				// this.bus.$emit('loading', true);
				this.tableLoading = true;
				this.page = pages ? pages : 1;
				var _this = this; 
				var isnotiontoggle = citytype == 'sort' && this.notionCode != 0 && !this.ucomputer; 
				var calcnc = isnotiontoggle ? '&calNotion=1&calCNC=1' :''; 
				// var notionstepd = this.notionstep;
				var ajaxurl = this.getajaxUrl(this.$api.cyl.enterprise.list(), searchtype) + '&page=' + this.page + calcnc;
				// console.log(ajaxurl)
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log('企业列表',ajaxurl, res.data);
					if (res.data.success) {
						var dataenterlist = res.data.list;
						_this.exportnum = res.data.extend.exportRemainder;
						_this.allowexport = res.data.extend.allowExport;
						if(isnotiontoggle){
							_this.isClearNotion=false;
							_this.notionNumRefresh++;
							_this.notionNumList=res.data.extend.cityNotionList;  
						}
						for (var i = 0; i < res.data.list.length; i++) {
							dataenterlist[i].notionlist = _this.taglistfun(dataenterlist[i].notion, dataenterlist[
								i].notionCode, 'notionsort');
							dataenterlist[i].taglist = _this.taglistfun(dataenterlist[i].tag, dataenterlist[i]
								.tagCode);
						}
						_this.totalPage = res.data.totalPage;
						_this.pageSize = res.data.pageSize;
						_this.total = res.data.totalRecord;
						_this.haspage = res.data.list.length == res.data.pageSize;
						_this.kwtextsearch = _this.searchtext != "";
						_this.kwtextsearchtext = _this.searchtext;
						_this.exportbtn = true;
						_this.confirmtext = "确认导出";
						_this.enterpristlist = dataenterlist;
						_this.tableLoading = false;
						_this.bus.$emit('loading', false);
						// console.log('isnotiontoggle:',isnotiontoggle);
						// if (isnotiontoggle) {
						// 	var citynotionlist = res.data.extend.cityNotionList;
						// 	var zancunNlist = [];
						// 	if (notionstepd == 1) {
						// 		zancunNlist = _this.zcnotionlist1;
						// 	} else if (notionstepd == 2) {
						// 		zancunNlist = _this.zcnotionlist2;
						// 	}
						// 	var citynotionlist1 = [];
						// 	for (var i = 0; i < citynotionlist.length; i++) {
						// 		for (var d = 0; d < zancunNlist.length; d++) {
						// 			if (citynotionlist[i].notionCode == zancunNlist[d].value) {
						// 				citynotionlist[i].children = zancunNlist[d].children;
						// 				citynotionlist[i].label = zancunNlist[d].label;
						// 				citynotionlist[i].value = zancunNlist[d].value;
						// 				citynotionlist1.push(citynotionlist[i]);
						// 				break;
						// 			}
						// 		}
						// 	}
						// 	// console.log(zancunNlist,citynotionlist) 
						// 	if (notionstepd == 1) { 
						// 		_this.notionlist1 = citynotionlist1;
						// 		// console.log(11411,_this.notionlist1,citynotionlist1)
						// 	} else if (notionstepd == 2) {
						// 		_this.notionlist2 = citynotionlist1;
						// 	} 
						// }
						
					}  
				}).catch(function(error) {});
				// console.log(datas);  
			},
			//  
		}
	}
</script>

<style>
</style>